import { SubscriptionFrequency } from "./types";

export const subscriptionFrequencies = [
  SubscriptionFrequency.MONTHLY,
  SubscriptionFrequency.QUARTERLY,
  SubscriptionFrequency.YEARLY,
];
